<div class="vnc-container">
    <iframe *ngIf="!errorMessage && iframeUrl" width="100%" height="100%" frameBorder="0" [src]="iframeUrl | safe" allowfullscreen></iframe>
    <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
</div>